






















import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  data() {
    return {
      snakeCase,
    }
  },
})
export default class ButtonHeader extends Vue {
  @Prop({ type: String, default: '' }) buttonName!: string

  get buttonHeaderDescription():string | null {
    if (this.$te(`field_button_${ snakeCase(this.buttonName) }_description`)) {
      return this.$t(`field_button_${ snakeCase(this.buttonName) }_description`).toString()
    }

    return null
  }
}
